import { colorsSet } from "../utils";

const rowData = (
  data: any[],
  head: string,
  colorSet: number,
  swap?: boolean,
) => {
  if (swap) data = mergeGradesByDate(data);

  const headerCell = getUniqueKeys(data);
  let columnCell = transformData(data, headerCell);
  if (columnCell.length) columnCell = formatObj(columnCell, head);

  return (
    <div key={`data-row-${Math.random()}`} className="wrapper-content-row">
      <div className="header-td-elevation">
        {columnCell.map((column: any, indexParent: number) => (
          <div
            key={`row-header-${Math.random()}`}
            className={`flex gap-4 px-4 py-2 border-row-data ${indexParent === 0 ? "header-th-title header-th-title-left" : undefined}`}
          >
            <div className="header-td">
              <div>
                {Object.keys(column)[0] ? Object.keys(column)[0] : "Unknown"}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div
        key={`row-section-${Math.random()}`}
        className="flex flex-1 max-w-5xl overflow-auto"
      >
        <div key={`row-subsection-${Math.random()}`} className="flex-1">
          {columnCell.map((column: any, indexParent: number) => (
            <div
              key={`row-data-${Math.random()}`}
              className={`${indexParent === 0 ? "header-th-title header-th-title-right" : "custom-hov"}`}
              style={
                {
                  "--hover-color":
                    indexParent > 0
                      ? colorsSet[colorSet + (indexParent - 1)]
                      : undefined,
                } as React.CSSProperties
              }
            >
              <div className="flex flex-1 items-center gap-4 px-4 py-2 border-row-data">
                {column[Object.keys(column)[0]].map((item: any) => (
                  <>
                    <div
                      className="flex flex-1 justify-center"
                      key={`data-obj-${Math.random()}`}
                      style={{
                        lineHeight:
                          (item ? item.length : 0) > 15 &&
                          column[Object.keys(column)[0]].length > 5
                            ? "11px"
                            : undefined,
                      }}
                    >
                      {item}
                    </div>
                  </>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const getUniqueKeys = (data: any[]) => {
  if (data.length === 0) return [];
  return Object.keys(data[0]).filter((key) => key !== "key");
};

const transformData = (data: any[], keys: any) =>
  keys.map((key: string) => ({ [key]: data.map((item) => item[key]) }));

const formatObj = (data: any[], head: string) => {
  const result: any[] = [];
  const metrics: { [key: string]: (number | string)[] } = {};

  data.forEach((entry) => {
    const key = Object.keys(entry)[0];
    metrics[key] = entry[key];
  });

  if (metrics[head]) {
    result.push({ [head]: metrics[head] });
    delete metrics[head];
  }

  for (const key in metrics) result.push({ [key]: metrics[key] });

  return result;
};

const mergeGradesByDate = (data: any) => {
  const result: any = [];

  data.forEach((item: any) => {
    const { date, ...grades } = item;
    let existingEntry = result.find((entry: any) => entry.date === date);

    if (existingEntry) Object.assign(existingEntry, grades);
    else result.push({ date, ...grades });
  });

  return result;
};

export default rowData;
